// extracted by mini-css-extract-plugin
module.exports = {"root":"CommonHeaderM_root__GFozX","title":"CommonHeaderM_title__U9x9e","actions":"CommonHeaderM_actions__xWzg3"};